import React, { useState, useEffect } from "react";
import { Button, Input, Select, SelectItem, Chip } from "@nextui-org/react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { toast } from "react-toastify";
import headerImg from "../../Assets/blog/head.png";
import featuredImg from "../../Assets/blog/featured.svg";
import navShawarImg from "../../Assets/blog/Nev.png";
import likeIcon from "../../Assets/blog/like.svg";
import unlikeIcon from "../../Assets/blog/unlike.svg";
import commentIcon from "../../Assets/blog/comment.svg";
import shareIcon from "../../Assets/blog/share.svg";
import searchIcon from "../../Assets/blog/search.svg";
import { FiSettings, FiFilter } from "react-icons/fi";
import egyptVideo from '../../Assets/Egypt.mp4';


// Blog Service - Centralized API calls using working API
const blogService = {
  // Public endpoint - requires token for access
  getAllBlogs: (token) => axios.get(`/blogs`, {
    headers: { Authorization: `Bearer ${token}` }
  }),
  
  // Admin endpoints (require auth token)
  getAdminAllBlogs: (token) => axios.get(`/admin/blogs`, {
    headers: { Authorization: `Bearer ${token}` }
  }),
  
  getMyBlogs: (token) => axios.get(`/admin/my-blogs`, {
    headers: { Authorization: `Bearer ${token}` }
  }),
  
  getBlogsByStatus: (status, token) => axios.get(`/admin/blogs/status/${status}`, {
    headers: { Authorization: `Bearer ${token}` }
  }),
  
  // Comment on blog using slug
  commentOnBlog: (slug, comment, token) => axios.post(
    `/blogs/${slug}/comment`,
    { comment },
    { headers: { Authorization: `Bearer ${token}` } }
  ),
  
  // Like/Unlike blog using slug
  likeBlog: (slug, token) => axios.post(
    `/blogs/${slug}/like`,
    {},
    { headers: { Authorization: `Bearer ${token}` } }
  ),
  
  // Get blog likes count
  getBlogLikes: (slug) => axios.get(`/blogs/${slug}/likes`),
  
  // Get blog comments count
  getBlogComments: (slug) => axios.get(`/blogs/${slug}/comments`),

  subscribeNewsletter: (email, token) => axios.post(`/newsletter-subscribe`,
    { email },
    { headers: { Authorization: `Bearer ${token}` } }
  ),

  // Get all categories and subcategories from admin API
  getAllCategories: (token) => axios.get(`/admin/blogs/categories/all`, {
    headers: { Authorization: `Bearer ${token}` }
  }),
  
  // Get subcategories for a specific main category
  getSubcategories: (mainCategory, token) => axios.get(
    `/blogs/categories/${mainCategory}/subcategories`,
    { headers: { Authorization: `Bearer ${token}` } }
  ),

};



// Default categories with subcategories structure (fallback)
const defaultCategories = [
  { value: "Travel Tips", label: "Travel Tips", hexColor: "#4F46E5" },
  { value: "Travel", label: "Travel", hexColor: "#0EA5E9" },
  { value: "Projects", label: "Projects", hexColor: "#10B981" },
  { value: "Event", label: "Event", hexColor: "#F59E0B" },
  { value: "Sport", label: "Sport", hexColor: "#EF4444" },
  { value: "Music", label: "Music", hexColor: "#8B5CF6" },
  { value: "Art", label: "Art", hexColor: "#EC4899" },
  { value: "Wellness", label: "Wellness", hexColor: "#06B6D4" },
  { value: "Lifestyle", label: "Lifestyle", hexColor: "#14B8A6" },
  { value: "Productivity", label: "Productivity", hexColor: "#F97316" },
  { value: "Seasonal", label: "Seasonal", hexColor: "#D946EF" },
  { value: "Stories", label: "Stories", hexColor: "#8B5CF6" },
  { value: "Technology", label: "Technology", hexColor: "#3B82F6" },
  { value: "Food", label: "Food", hexColor: "#10B981" },
  { value: "Business", label: "Business", hexColor: "#0EA5E9" },
  { value: "Education", label: "Education", hexColor: "#8B5CF6" },
  { value: "Finance", label: "Finance", hexColor: "#10B981" },
  { value: "Health", label: "Health", hexColor: "#EF4444" },
  { value: "Photography", label: "Photography", hexColor: "#8B5CF6" },
  { value: "Books", label: "Books", hexColor: "#F59E0B" },
];

// Default subcategories for each main category
const defaultSubcategories = {
  "Travel Tips": [
    { value: "travel-tips-packing", label: "Packing Tips" },
    { value: "travel-tips-budget", label: "Budget Travel Tips" },
    { value: "travel-tips-safety", label: "Safety Tips" },
    { value: "travel-tips-planning", label: "Trip Planning" },
    { value: "travel-tips-accommodation", label: "Accommodation Tips" },
    { value: "travel-tips-transportation", label: "Transportation Tips" },
    { value: "travel-tips-food", label: "Food & Dining Tips" },
  ],
  "Travel": [
    { value: "travel-adventure", label: "Adventure Travel" },
    { value: "travel-budget", label: "Budget Travel" },
    { value: "travel-luxury", label: "Luxury Travel" },
    { value: "travel-solo", label: "Solo Travel" },
    { value: "travel-family", label: "Family Travel" },
    { value: "travel-backpacking", label: "Backpacking" },
    { value: "travel-road-trip", label: "Road Trips" },
    { value: "travel-beach", label: "Beach Destinations" },
    { value: "travel-mountain", label: "Mountain Getaways" },
    { value: "travel-cultural", label: "Cultural Immersion" },
    { value: "travel-food", label: "Food & Culinary Travel" },
    { value: "travel-wellness", label: "Wellness Retreats" },
  ],
  "Projects": [
    { value: "projects-diy", label: "DIY Projects" },
    { value: "projects-home-improvement", label: "Home Improvement" },
    { value: "projects-gardening", label: "Gardening Projects" },
    { value: "projects-crafts", label: "Crafts & Art Projects" },
    { value: "projects-tech", label: "Tech Projects" },
    { value: "projects-woodworking", label: "Woodworking" },
    { value: "projects-renovation", label: "Home Renovation" },
    { value: "projects-upcycling", label: "Upcycling Projects" },
  ],
  "Event": [
    { value: "event-weddings", label: "Weddings" },
    { value: "event-birthdays", label: "Birthdays" },
    { value: "event-Art", label: "Arts & Culture" },
    { value: "event-corporate", label: "Corporate" },
    { value: "event-conferences", label: "Conferences" },
    { value: "event-festivals", label: "Festivals" },
    { value: "event-Music & Nightlife", label: "Music & Nightlife" },
    { value: "event-sports", label: "Sports" },
    { value: "event-charity", label: "Charity" },
    { value: "event-exhibitions", label: "Exhibitions" },
    { value: "event-launches", label: "Product Launches" },
    { value: "event-fashion", label: "Fashion" },
    { value: "event-Family & Lifestyle", label: "Family & Lifestyle" },
  ],
  "Sport": [
    { value: "sport-football", label: "Football" },
    { value: "sport-basketball", label: "Basketball" },
    { value: "sport-tennis", label: "Tennis" },
    { value: "sport-golf", label: "Golf" },
    { value: "sport-cricket", label: "Cricket" },
    { value: "sport-rugby", label: "Rugby" },
    { value: "sport-swimming", label: "Swimming" },
    { value: "sport-running", label: "Running" },
    { value: "sport-cycling", label: "Cycling" },
    { value: "sport-yoga", label: "Yoga" },
    { value: "sport-gym", label: "Gym & Fitness" },
    { value: "sport-extreme", label: "Extreme Sports" },
    { value: "sport-esports", label: "eSports" },
  ],
  "Wellness": [
    { value: "wellness-meditation", label: "Meditation" },
    { value: "wellness-yoga", label: "Yoga" },
    { value: "wellness-nutrition", label: "Nutrition" },
    { value: "wellness-fitness", label: "Fitness" },
    { value: "wellness-mental-health", label: "Mental Health" },
    { value: "wellness-sleep", label: "Sleep & Recovery" },
    { value: "wellness-holistic", label: "Holistic Health" },
    { value: "wellness-spa", label: "Spa & Relaxation" },
    { value: "wellness-ayurveda", label: "Ayurveda" },
    { value: "wellness-acupuncture", label: "Acupuncture" },
    { value: "wellness-massage", label: "Massage Therapy" },
    { value: "wellness-diet", label: "Diet & Detox" },
    { value: "wellness-mindfulness", label: "Mindfulness" },
  ],
  "Lifestyle": [
    { value: "lifestyle-fashion", label: "Fashion & Style" },
    { value: "lifestyle-beauty", label: "Beauty" },
    { value: "lifestyle-home", label: "Home & Decor" },
    { value: "lifestyle-relationships", label: "Relationships" },
    { value: "lifestyle-parenting", label: "Parenting" },
    { value: "lifestyle-pets", label: "Pets" },
    { value: "lifestyle-minimalism", label: "Minimalism" },
    { value: "lifestyle-sustainable", label: "Sustainable Living" },
    { value: "lifestyle-hobbies", label: "Hobbies" },
    { value: "lifestyle-entertainment", label: "Entertainment" },
    { value: "lifestyle-social", label: "Social Life" },
    { value: "lifestyle-personal-growth", label: "Personal Growth" },
  ],
  "Productivity": [
    { value: "productivity-time-management", label: "Time Management" },
    { value: "productivity-goal-setting", label: "Goal Setting" },
    { value: "productivity-habits", label: "Habit Building" },
    { value: "productivity-focus", label: "Focus & Concentration" },
    { value: "productivity-tools", label: "Productivity Tools" },
    { value: "productivity-work-life", label: "Work-Life Balance" },
    { value: "productivity-organization", label: "Organization" },
    { value: "productivity-planning", label: "Planning Systems" },
    { value: "productivity-motivation", label: "Motivation" },
    { value: "productivity-delegation", label: "Delegation" },
    { value: "productivity-remote-work", label: "Remote Work" },
    { value: "productivity-learning", label: "Learning Efficiency" },
  ],
  "Seasonal": [
    { value: "seasonal-christmas", label: "Christmas" },
    { value: "seasonal-halloween", label: "Halloween" },
    { value: "seasonal-easter", label: "Easter" },
    { value: "seasonal-new-year", label: "New Year" },
    { value: "seasonal-valentines", label: "Valentine's Day" },
    { value: "seasonal-thanksgiving", label: "Thanksgiving" },
    { value: "seasonal-summer", label: "Summer Activities" },
    { value: "seasonal-winter", label: "Winter Activities" },
    { value: "seasonal-spring", label: "Spring Activities" },
    { value: "seasonal-autumn", label: "Autumn Activities" },
    { value: "seasonal-holidays", label: "Holiday Planning" },
    { value: "seasonal-festivals", label: "Seasonal Festivals" },
  ],
  "Stories": [
    { value: "stories-personal", label: "Personal Stories" },
    { value: "stories-travel", label: "Travel Stories" },
    { value: "stories-fiction", label: "Fiction" },
    { value: "stories-inspirational", label: "Inspirational Stories" },
    { value: "stories-humorous", label: "Humorous Stories" },
    { value: "stories-mystery", label: "Mystery" },
    { value: "stories-romance", label: "Romance" },
    { value: "stories-adventure", label: "Adventure Stories" },
    { value: "stories-historical", label: "Historical Stories" },
    { value: "stories-fantasy", label: "Fantasy" },
    { value: "stories-sci-fi", label: "Science Fiction" },
    { value: "stories-interviews", label: "Interviews" },
  ],
  "Technology": [
    { value: "tech-ai", label: "Artificial Intelligence" },
    { value: "tech-web", label: "Web Development" },
    { value: "tech-mobile", label: "Mobile Development" },
    { value: "tech-gadgets", label: "Gadgets & Reviews" },
    { value: "tech-security", label: "Cybersecurity" },
    { value: "tech-software", label: "Software Engineering" },
    { value: "tech-blockchain", label: "Blockchain & Crypto" },
    { value: "tech-data-science", label: "Data Science" },
    { value: "tech-cloud", label: "Cloud Computing" },
    { value: "tech-iot", label: "Internet of Things" },
    { value: "tech-gaming", label: "Gaming" },
    { value: "tech-startups", label: "Startups & Innovation" },
    { value: "tech-programming", label: "Programming Languages" },
    { value: "tech-hardware", label: "Hardware" },
    { value: "tech-robotics", label: "Robotics" },
    { value: "tech-vr-ar", label: "VR & AR" },
  ],
  "Food": [
    { value: "food-recipes", label: "Recipes" },
    { value: "food-restaurants", label: "Restaurant Reviews" },
    { value: "food-healthy", label: "Healthy Eating" },
    { value: "food-baking", label: "Baking" },
    { value: "food-vegan", label: "Vegan & Vegetarian" },
    { value: "food-desserts", label: "Desserts" },
    { value: "food-drinks", label: "Drinks & Beverages" },
    { value: "food-cooking-tips", label: "Cooking Tips" },
    { value: "food-meal-prep", label: "Meal Prep" },
    { value: "food-international", label: "International Cuisine" },
    { value: "food-street-food", label: "Street Food" },
    { value: "food-fine-dining", label: "Fine Dining" },
    { value: "food-food-travel", label: "Food Travel" },
  ],
  "Business": [
    { value: "business-entrepreneurship", label: "Entrepreneurship" },
    { value: "business-marketing", label: "Marketing" },
    { value: "business-finance", label: "Finance" },
    { value: "business-management", label: "Management" },
    { value: "business-leadership", label: "Leadership" },
    { value: "business-sales", label: "Sales" },
    { value: "business-investing", label: "Investing" },
    { value: "business-strategy", label: "Business Strategy" },
    { value: "business-startups", label: "Startups" },
    { value: "business-ecommerce", label: "E-commerce" },
  ],
  "Education": [
    { value: "education-learning", label: "Learning Techniques" },
    { value: "education-online", label: "Online Education" },
    { value: "education-career", label: "Career Development" },
    { value: "education-languages", label: "Language Learning" },
    { value: "education-skill-development", label: "Skill Development" },
    { value: "education-study-tips", label: "Study Tips" },
    { value: "education-parenting", label: "Education & Parenting" },
  ],
  "Finance": [
    { value: "finance-investing", label: "Investing" },
    { value: "finance-saving", label: "Saving Money" },
    { value: "finance-budgeting", label: "Budgeting" },
    { value: "finance-stocks", label: "Stock Market" },
    { value: "finance-crypto", label: "Cryptocurrency" },
    { value: "finance-real-estate", label: "Real Estate" },
    { value: "finance-taxes", label: "Tax Planning" },
  ],
  "Health": [
    { value: "health-fitness", label: "Fitness" },
    { value: "health-nutrition", label: "Nutrition" },
    { value: "health-mental", label: "Mental Health" },
    { value: "health-chronic", label: "Chronic Conditions" },
    { value: "health-preventive", label: "Preventive Care" },
    { value: "health-alternative", label: "Alternative Medicine" },
  ],
  "Photography": [
    { value: "photography-portrait", label: "Portrait Photography" },
    { value: "photography-landscape", label: "Landscape Photography" },
    { value: "photography-street", label: "Street Photography" },
    { value: "photography-wildlife", label: "Wildlife Photography" },
    { value: "photography-editing", label: "Photo Editing" },
    { value: "photography-equipment", label: "Camera Equipment" },
  ],

};



// Helper function to get category color
const getCategoryHexColor = (categoryName) => {
  if (!categoryName) return "#4F46E5";
  const found = defaultCategories.find(cat => cat.value === categoryName || cat.label === categoryName);
  return found?.hexColor || "#4F46E5";
};

// Helper function to get subcategory label
const getSubcategoryLabel = (mainCategory, subcategoryValue) => {
  if (!subcategoryValue || !mainCategory) return "";
  const subcategories = defaultSubcategories[mainCategory] || [];
  const found = subcategories.find(sub => sub.value === subcategoryValue);
  return found?.label || subcategoryValue || "";
};



// Helper to check if user is admin
// Replace the existing checkIfAdmin function with this:
const checkIfAdmin = async (token) => {
  if (!token) return false;
  
  try {
    // Try to get user from localStorage first (faster)
    const userData = localStorage.getItem("user_data");
    if (userData) {
      const parsed = JSON.parse(userData);
      const adminIds = [4, 83];
      const userId = parseInt(parsed?.id);
      if (adminIds.includes(userId)) {
        return true;
      }
    }
    
    // If not in localStorage, fetch from API
    const response = await axios.get('/user', {
      headers: { Authorization: `Bearer ${token}` }
    });
    
    const userId = response.data.id;
    const adminIds = [4, 83];
    const isAdmin = adminIds.includes(userId);
    
    // Store in localStorage for future use
    if (isAdmin) {
      localStorage.setItem("user_data", JSON.stringify(response.data));
    }
    
    return isAdmin;
  } catch (error) {
    console.error('Error checking admin status:', error);
    return false;
  }
};



// Helper to format date
const formatDate = (dateString) => {
  if (!dateString) return '';
  const date = new Date(dateString);
  return date.toLocaleDateString('en-US', {
    year: 'numeric',
    month: 'short',
    day: 'numeric'
  });
};

// PostCard Component
const PostCard = ({ 
  post, 
  navigate,
  getCategoryColor,
  getCategoryHexColor,
  getSubcategoryLabel,
  formatDate,
  handleLike,
  toggleComments,
  expandedComments,
  newComments,
  setNewComments,
  handleAddComment,
  handleShare,
  featuredImg,
  navShawarImg,
  likeIcon,
  unlikeIcon,
  commentIcon,
  shareIcon
}) => {
  return (
    <div
      className="bg-white rounded-3xl border-2 border-solid border-cardColor overflow-hidden hover:shadow-xl transition-shadow duration-300 cursor-pointer snap-center flex-shrink-0 w-[350px] sm:w-[420px]"
      onClick={() => navigate(`/blogs/${post.slug}`)}
    >
      {/* Post Image */}
      <div className="relative h-48">
        <img
          src={post.image || post.featured_image || featuredImg}
          alt={post.title}
          className="object-cover w-full h-full"
          onError={(e) => {
            console.error("Post image failed to load:", e.target.src);
            e.target.src = featuredImg;
          }}
        />
        {/* Main Category Badge */}
        {post.category && (
          <span 
            className="absolute px-3 py-1 text-xs font-semibold text-white rounded-full top-4 left-4"
            style={{ backgroundColor: getCategoryColor(post.category) }}
          >
            {post.category}
          </span>
        )}
        {/* Subcategory Badges - Show all subcategories */}
        {(() => {
          const subcategories = [];
          // Get subcategories from categories array (format: [mainCategory, sub1, sub2, ...])
          if (Array.isArray(post.categories) && post.categories.length > 1) {
            for (let i = 1; i < post.categories.length; i++) {
              const sub = post.categories[i];
              if (sub) {
                subcategories.push({
                  value: sub,
                  label: getSubcategoryLabel(post.category, sub) || sub
                });
              }
            }
          }
          // Also add from subcategory field if exists and not already included
          if (post.subcategory && !subcategories.some(s => s.value === post.subcategory)) {
            subcategories.push({
              value: post.subcategory,
              label: getSubcategoryLabel(post.category, post.subcategory) || post.subcategory
            });
          }
          
          if (subcategories.length === 0) return null;
          
          return (
            <div className="absolute top-4 right-4 flex flex-wrap gap-1 justify-end max-w-[60%]">
              {subcategories.map((sub, index) => (
                <span 
                  key={sub.value}
                  className="px-2 py-1 text-xs font-medium text-white rounded-full bg-black/60"
                >
                  {sub.label}
                </span>
              ))}
            </div>
          );
        })()}
      </div>

      {/* Post Content */}
      <div className="p-6">
        <h4 className="mb-3 text-xl font-bold text-gray-900 line-clamp-2">
          {post.title}
        </h4>
        <p className="mb-4 text-sm text-gray-600 line-clamp-3">
          {post.excerpt || "No excerpt available"}
        </p>

        {/* Author & Date */}
        <div className="flex items-center gap-2 mb-4">
          <div className="flex items-center justify-center w-8 h-8 overflow-hidden rounded-full bg-mainGradiant">
            {post.user?.img_url ? (
              <img 
                src={post.user.img_url} 
                alt={post.user.name || "Nev Shawer"}
                className="object-cover w-full h-full"
                onError={(e) => {
                  e.target.onerror = null;
                  e.target.src = navShawarImg;
                }}
              />
            ) : (
              <img 
                src={navShawarImg} 
                alt="Nev Shawer" 
                className="object-cover w-full h-full"
              />
            )}
          </div>
          <span className="text-sm text-gray-500">{post.user?.name || "Nev Shawer"}</span>
          <span className="text-sm text-gray-400">•</span>
          <span className="text-sm text-gray-500">
            {formatDate(post.published_at || post.created_at)}
          </span>
        </div>

        {/* Interactive Actions */}
        <div className="pt-4 border-t border-gray-100">
          <div className="flex items-center justify-between">
            {/* Like Button */}
            <button
              onClick={(e) => { e.stopPropagation(); handleLike(post); }}
              className={`flex items-center gap-2 transition-all duration-300 ${
                post.is_liked ? "text-[#E65CA7]" : "text-gray-500"
              }`}
            >
              <div className="w-6 h-6">
                <img
                  src={post.is_liked ? likeIcon : unlikeIcon}
                  alt="Like"
                  className="w-full h-full"
                />
              </div>
              <span className="text-sm font-medium">{post.likes_count || 0}</span>
            </button>

            {/* Comment Button */}
            <button
              onClick={(e) => { e.stopPropagation(); toggleComments(post.id); }}
              className="flex items-center gap-2 text-gray-500 transition-all duration-300 hover:text-blue-500"
            >
              <div className="w-6 h-6">
                <img
                  src={commentIcon}
                  alt="Comments"
                  className="w-full h-full"
                />
              </div>
              <span className="text-sm font-medium">{post.comments_count || 0}</span>
            </button>

            {/* Share Button */}
            <button
              onClick={(e) => { e.stopPropagation(); handleShare(post); }}
              className="flex items-center gap-2 text-gray-500 transition-all duration-300 hover:text-green-500"
            >
              <div className="w-6 h-6">
                <img
                  src={shareIcon}
                  alt="Share"
                  className="w-full h-full"
                />
              </div>
              <span className="text-sm font-medium">Share</span>
            </button>
          </div>

          {/* Expanded Comments Section */}
          {expandedComments[post.id] && (
            <div className="pt-4 mt-4 border-t border-gray-100" onClick={(e) => e.stopPropagation()}>
              {/* Add Comment */}
              <div className="flex gap-2 mb-4">
                <Input
                  type="text"
                  placeholder="Add a comment..."
                  size="sm"
                  className="flex-1"
                  value={newComments[post.id] || ""}
                  onChange={(e) => setNewComments({ ...newComments, [post.id]: e.target.value })}
                  onKeyPress={(e) => e.key === "Enter" && handleAddComment(post)}
                />
                <Button
                  size="sm"
                  className="px-4 text-white rounded-full bg-mainGradiant"
                  onClick={() => handleAddComment(post)}
                >
                  Post
                </Button>
              </div>
              
              <p className="text-xs text-center text-gray-500">
                Note: Comments are handled by a separate system
              </p>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

// Mock categories based on blog data
const getCategoriesFromPosts = (posts) => {
  const categoryCounts = {};
  
  posts.forEach(post => {
    if (post.category) {
      // Normalize category name (trim whitespace)
      const normalizedCategory = post.category.trim();
      categoryCounts[normalizedCategory] = (categoryCounts[normalizedCategory] || 0) + 1;
    }
  });
  
  // Default colors for categories
  const categoryColors = {
    "Travel Tips": "#4F46E5",
    "Travel": "#4F46E5",
    "Projects": "#10B981",
    "Event": "#F59E0B",
    "Sports": "#3B82F6",
    "Music": "#EF4444",
    "Arts": "#8B5CF6",
    "Wellness": "#EC4899",
    "Lifestyle": "#06B6D4",
    "Productivity": "#EF4444",
    "Seasonal": "#8B5CF6",
    "Stories": "#EC4899",
    "Technology": "#8B5CF6",
    "Lifestyle": "#06B6D4"
  };
  
  return Object.entries(categoryCounts).map(([name, count]) => ({
    name,
    count,
    color: categoryColors[name] || categoryColors[name.toLowerCase()] || "#4F46E5"
  }));
};

// Static blog posts for fallback
const staticBlogPosts = [
  {
    id: 1,
    slug: "travel-tips-cairo-egypt",
    title: "Travel Tips for Cairo, Egypt: What You Need to Know Before You Go",
    excerpt: "Cairo is a city of contrasts—ancient and modern, chaotic and captivating, overwhelming and unforgettable.",
    category: "Travel Tips",
    featured_image: featuredImg,
    user: { name: "Nev Shawer" },
    published_at: "2024-12-15",
    is_published: true,
    likes_count: 245,
    comments_count: 2
  }
];

const Blog = () => {
  const navigate = useNavigate();
  
  // State
  const [posts, setPosts] = useState([]);
  const [categories, setCategories] = useState([]);
  const [mainCategories, setMainCategories] = useState([]);
  const [subcategories, setSubcategories] = useState([]);
  const [featuredPost, setFeaturedPost] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [expandedComments, setExpandedComments] = useState({});
  const [newComments, setNewComments] = useState({});
  const [shareModal, setShareModal] = useState({ show: false, postId: null });
  const [activeCategory, setActiveCategory] = useState("All");
  const [selectedSubcategory, setSelectedSubcategory] = useState("");
  const [activeSubcategory, setActiveSubcategory] = useState("");
  const [openDropdown, setOpenDropdown] = useState(null); // Track which dropdown is open
  const [searchQuery, setSearchQuery] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [isAdmin, setIsAdmin] = useState(false);
  const [email, setEmail] = useState("");
  const [isSubscribing, setIsSubscribing] = useState(false);
  const [subscriptionSuccess, setSubscriptionSuccess] = useState(false);
  const [categoriesLoading, setCategoriesLoading] = useState(true);
const [checkingAdmin, setCheckingAdmin] = useState(true);
  
  const postsPerPage = 6;
  const token = localStorage.getItem("token");
  const isAuthenticated = !!token;

useEffect(() => {
  const checkAdminStatus = () => {
    try {
      // First check localStorage for user_data
      const userData = localStorage.getItem("user_data");
      // console.log('🔍 AdminBlogManage - Checking admin status');
      // console.log('📦 user_data from localStorage:', userData);
      
      if (userData) {
        const parsed = JSON.parse(userData);
        const adminIds = [4, 83];
        const userId = parseInt(parsed?.id);
        const isUserAdmin = adminIds.includes(userId);
        
        // console.log('👤 User ID:', userId);
        // console.log('✅ Is Admin:', isUserAdmin);
        
        setIsAdmin(isUserAdmin);
        
        if (!isUserAdmin) {
          // toast.error("Access denied. Admin only.");
          navigate("/blogs");
        }
      } else {
        // Try to get token and fetch user
        const token = localStorage.getItem("token");
        if (token) {
          axios.get('/user', {
            headers: { Authorization: `Bearer ${token}` }
          })
          .then(response => {
            const userId = response.data.id;
            const adminIds = [4, 83];
            const isUserAdmin = adminIds.includes(userId);
            setIsAdmin(isUserAdmin);
            
            // Store in localStorage for future
            localStorage.setItem("user_data", JSON.stringify(response.data));
            
            if (!isUserAdmin) {
              // toast.error("Access denied. Admin only.");
              navigate("/blogs");
            }
          })
          .catch(error => {
            console.error('Error fetching user:', error);
            toast.error("Access denied. Please login again.");
            navigate("/login");
          });
        } else {
          // console.log('No token found');
          toast.error("Please login first");
          navigate("/login");
        }
      }
    } catch (error) {
      console.error('Error checking admin status:', error);
      toast.error("Access denied");
      navigate("/blogs");
    } finally {
      setCheckingAdmin(false);
    }
  };
  
  checkAdminStatus();
}, [navigate]);

// Also check token from localStorage
// useEffect(() => {
//   const token = localStorage.getItem("token");
//   console.log('🔐 Token in AdminBlogManage:', token ? 'Token exists' : 'No token');
// }, []);

  // Add this useEffect to debug your user ID
useEffect(() => {
  const checkUserId = async () => {
    if (token) {
      try {
        const response = await axios.get('/user', {
          headers: { Authorization: `Bearer ${token}` }
        });
        // console.log('🔍 Current user data:', response.data);
        // console.log('🔍 Your user ID:', response.data.id);
        
        const adminIds = [4, 83];
        // console.log('🔍 Is admin?', adminIds.includes(response.data.id));
      } catch (error) {
        console.error('Error fetching user:', error);
      }
    }
  };
  
  checkUserId();
}, [token]);

  // Fetch categories from API
  const fetchCategories = async () => {
    try {
      setCategoriesLoading(true);
      const response = await blogService.getAllCategories(token);
      
      if (response.data.success) {
        const data = response.data.data;
        
        // Parse main_categories (JSON string or array)
        let mainCats = [];
        if (data.main_categories) {
          try {
            mainCats = typeof data.main_categories === 'string' 
              ? JSON.parse(data.main_categories) 
              : data.main_categories;
          } catch (e) {
            console.error('Error parsing main_categories:', e);
            mainCats = defaultCategories.map(c => c.value || c.label || c);
          }
        }
        
        // Parse subcategories (JSON string or object)
        let subs = {};
        if (data.subcategories) {
          try {
            subs = typeof data.subcategories === 'string' 
              ? JSON.parse(data.subcategories) 
              : data.subcategories;
          } catch (e) {
            console.error('Error parsing subcategories:', e);
            subs = defaultSubcategories;
          }
        }
        
        setMainCategories(mainCats);
        setSubcategories(subs);
      }
    } catch (error) {
      console.error('Error fetching categories:', error);
      // Use default categories as fallback
      setMainCategories(defaultCategories.map(c => c.value || c.label || c));
      setSubcategories(defaultSubcategories);
    } finally {
      setCategoriesLoading(false);
    }
  };

  // Get subcategories for a specific main category
  const getAvailableSubcategories = (mainCat) => {
    if (!mainCat || mainCat === "All") return [];
    return subcategories[mainCat] || defaultSubcategories[mainCat] || [];
  };

  // Fetch blogs on mount
  useEffect(() => {
    fetchBlogs();
    fetchCategories();
    if (isAuthenticated) {
      checkAdminStatus();
    }
  }, [isAuthenticated]);

  // Fetch blogs from API
  const fetchBlogs = async () => {
    setIsLoading(true);
    try {
      const response = await blogService.getAllBlogs(token);
      let blogs = response.data.data || response.data;
      
      // Ensure blogs is an array
      if (!Array.isArray(blogs)) {
        blogs = [];
      }
      
      // Fetch likes and comments counts for each blog post if not provided
      const enrichedBlogs = await Promise.all(
        blogs.map(async (post) => {
          try {
            // Try to get likes count
            let likes_count = post.likes_count;
            let comments_count = post.comments_count;
            
            if (post.slug) {
              try {
                const likesResponse = await blogService.getBlogLikes(post.slug);
                if (likesResponse.data && typeof likesResponse.data.likes_count === 'number') {
                  likes_count = likesResponse.data.likes_count;
                }
              } catch (e) {
                //console.log('Could not fetch likes for', post.slug);
              }
              
              try {
                const commentsResponse = await blogService.getBlogComments(post.slug);
                if (commentsResponse.data && Array.isArray(commentsResponse.data.comments)) {
                  comments_count = commentsResponse.data.comments.length;
                }
              } catch (e) {
                //console.log('Could not fetch comments for', post.slug);
              }
            }
            
            return {
              ...post,
              likes_count: likes_count || 0,
              comments_count: comments_count || 0
            };
          } catch (error) {
            return {
              ...post,
              likes_count: post.likes_count || 0,
              comments_count: post.comments_count || 0
            };
          }
        })
      );
      
      // Set posts with enriched data
      setPosts(enrichedBlogs);
      
      // Set featured post (first published post or most recent)
      if (enrichedBlogs.length > 0) {
        const publishedBlogs = enrichedBlogs.filter(blog => blog.is_published);
        if (publishedBlogs.length > 0) {
          setFeaturedPost(publishedBlogs[0]);
        } else {
          setFeaturedPost(enrichedBlogs[0]);
        }
      }
      
      // Generate categories from posts
      const generatedCategories = getCategoriesFromPosts(enrichedBlogs);
      setCategories(generatedCategories);
      
      // Calculate total pages
      const filtered = filterPosts(enrichedBlogs, "All", "", "");
      setTotalPages(Math.ceil(filtered.length / postsPerPage));
      
    } catch (error) {
      console.error("Error fetching blogs:", error);
      // Use static fallback data when API fails
      setPosts(staticBlogPosts);
      if (staticBlogPosts.length > 0) {
        setFeaturedPost(staticBlogPosts[0]);
      }
      const staticCategories = getCategoriesFromPosts(staticBlogPosts);
      setCategories(staticCategories);
      setTotalPages(Math.ceil(staticBlogPosts.length / postsPerPage));
    } finally {
      setIsLoading(false);
    }
  };

 const handleSubscribe = async () => {
    // Check if user is authenticated
    if (!isAuthenticated) {
      toast.info("Please login or sign up to subscribe to our newsletter");
      navigate("/login");
      return;
    }
    
    if (!email.trim()) {
      toast.error("Please enter a valid email address");
      return;
    }
    
    // Basic email validation
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(email)) {
      toast.error("Please enter a valid email address");
      return;
    }
    
    setIsSubscribing(true);
    try {
      await blogService.subscribeNewsletter(email, token);
      
      setSubscriptionSuccess(true);
      setEmail("");
      toast.success("Successfully subscribed to newsletter!");
      
      // Reset success message after 3 seconds
      setTimeout(() => {
        setSubscriptionSuccess(false);
      }, 3000);
      
    } catch (error) {
      console.error("Subscription error:", error);
      
      // Handle different error cases
      if (error.response?.status === 401) {
        toast.error("Session expired. Please login again.");
        localStorage.removeItem("token");
        navigate("/login");
      } else if (error.response?.status === 422) {
        const errorMessage = error.response?.data?.message;
        if (errorMessage?.includes("already subscribed") || errorMessage?.includes("already exists")) {
          toast.info("You're already subscribed to our newsletter!");
        } else {
          toast.error("Invalid email address. Please check and try again.");
        }
      } else if (error.response?.status === 429) {
        toast.error("Too many attempts. Please try again later.");
      } else {
        toast.error(error.response?.data?.message || "Failed to subscribe. Please try again.");
      }
    } finally {
      setIsSubscribing(false);
    }
  };
  
  // Optional: Pre-fill email from user data if available
  useEffect(() => {
    const fetchUserEmail = async () => {
      if (isAuthenticated && token) {
        try {
          const response = await axios.get('/user', {
            headers: { Authorization: `Bearer ${token}` }
          });
          if (response.data.email) {
            setEmail(response.data.email);
          }
        } catch (error) {
          //console.log("Could not fetch user email:", error);
        }
      }
    };
    
    fetchUserEmail();
  }, [isAuthenticated, token]);

  // Check admin status
 // Update the checkAdminStatus function
const checkAdminStatus = async () => {
  if (token) {
    const adminStatus = await checkIfAdmin(token);
    // console.log('Admin status:', adminStatus);
    setIsAdmin(adminStatus);
  } else {
    // console.log('No token found');
    setIsAdmin(false);
  }
};

  // Filter posts function
  const filterPosts = (postsList, category, subcategory, query) => {
    return postsList.filter(post => {
      // Case-insensitive category matching
      const matchesCategory = category === "All" || 
        (post.category && post.category.toLowerCase().trim() === category.toLowerCase().trim());
      
      // Subcategory matching - check if post has the selected subcategory
      const matchesSubcategory = !subcategory || subcategory === "" || 
        (post.subcategory && post.subcategory.toLowerCase().trim() === subcategory.toLowerCase().trim()) ||
        // Also check in categories array format
        (Array.isArray(post.categories) && post.categories.some(cat => cat && cat.toLowerCase().trim() === subcategory.toLowerCase().trim()));
      
      const matchesSearch = query === "" || 
        (post.title && post.title.toLowerCase().includes(query.toLowerCase())) ||
        (post.excerpt && post.excerpt.toLowerCase().includes(query.toLowerCase())) ||
        (post.user?.name && post.user.name.toLowerCase().includes(query.toLowerCase()));
      
      return matchesCategory && matchesSubcategory && matchesSearch && post.is_published;
    });
  };

  // Get current posts based on filters and pagination
  const getCurrentPosts = () => {
    const filtered = filterPosts(posts, activeCategory, activeSubcategory, searchQuery);
    const startIndex = (currentPage - 1) * postsPerPage;
    return filtered.slice(startIndex, startIndex + postsPerPage);
  };

  // Handle like using slug-based API
  const handleLike = async (post) => {
    if (!token) {
      toast.info("Please login to like posts");
      return;
    }
    
    if (!post?.slug) {
      toast.error("Invalid blog post");
      return;
    }
    
    // Store previous state for rollback
    const previousLikesCount = post.likes_count;
    const previousIsLiked = post.is_liked;
    
    // Optimistically update UI
    setPosts(posts.map(p => {
      if (p.id === post.id) {
        return {
          ...p,
          likes_count: previousIsLiked 
            ? Math.max(0, (p.likes_count || 0) - 1) 
            : (p.likes_count || 0) + 1,
          is_liked: !previousIsLiked
        };
      }
      return p;
    }));
    
    try {
      // Using slug-based API endpoint
      const { data } = await blogService.likeBlog(post.slug, token);
      
      // Update with actual server response
      setPosts(posts.map(p => {
        if (p.id === post.id) {
          return {
            ...p,
            likes_count: data.likes_count,
            is_liked: data.message === "Blog liked" || data.message === "Blog unliked" 
              ? !previousIsLiked 
              : data.is_liked ?? !previousIsLiked
          };
        }
        return p;
      }));
      
      toast.success(data.message || (previousIsLiked ? "Blog unliked" : "Blog liked"));
    } catch (error) {
      // Rollback to previous state on error
      setPosts(posts.map(p => {
        if (p.id === post.id) {
          return {
            ...p,
            likes_count: previousLikesCount,
            is_liked: previousIsLiked
          };
        }
        return p;
      }));
      toast.error(error?.response?.data?.message || "Failed to like/unlike blog");
    }
  };

  const toggleComments = (postId) => {
    setExpandedComments(prev => ({
      ...prev,
      [postId]: !prev[postId]
    }));
  };

  // Handle add comment using slug-based API
  const handleAddComment = async (post) => {
    const commentText = newComments[post.id]?.trim();
    if (!commentText) return;
    
    if (!token) {
      toast.info("Please login to comment");
      return;
    }
    
    if (!post?.slug) {
      toast.error("Invalid blog post");
      return;
    }
    
    // Optimistically add comment to UI (temporary)
    const tempComment = {
      id: Date.now(),
      comment: commentText,
      user: { name: "You" },
      created_at: new Date().toISOString(),
      like_count: 0,
      is_liked: false,
      replies: []
    };
    
    setPosts(posts.map(p => {
      if (p.id === post.id) {
        return {
          ...p,
          comments_count: (p.comments_count || 0) + 1
        };
      }
      return p;
    }));
    
    // Clear comment input
    setNewComments({ ...newComments, [post.id]: "" });
    
    try {
      await blogService.commentOnBlog(post.slug, commentText, token);
      toast.success("Comment added!");
      
      // Refresh posts to get updated comments count
      fetchBlogs();
    } catch (error) {
      console.error("Error adding comment:", error);
      
      // Rollback optimistic update
      setPosts(posts.map(p => {
        if (p.id === post.id) {
          return {
            ...p,
            comments_count: Math.max(0, (p.comments_count || 0) - 1)
          };
        }
        return p;
      }));
      
      toast.error(error?.response?.data?.message || "Failed to add comment");
    }
  };

  const handleShare = (post) => {
    const shareData = {
      title: post.title,
      text: post.excerpt,
      url: window.location.origin + `/blogs/${post.slug}`
    };

    if (navigator.share) {
      navigator.share(shareData).catch(console.error);
    } else {
      navigator.clipboard.writeText(shareData.url).then(() => {
        setShareModal({ show: true, postId: post.id });
        setTimeout(() => setShareModal({ show: false, postId: null }), 2000);
      });
    }
  };

  // Handle search and category changes
  useEffect(() => {
    const filtered = filterPosts(posts, activeCategory, activeSubcategory, searchQuery);
    setTotalPages(Math.ceil(filtered.length / postsPerPage));
    setCurrentPage(1);
  }, [activeCategory, activeSubcategory, searchQuery, posts]);

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (e) => {
      if (openDropdown !== null) {
        setOpenDropdown(null);
      }
    };

    document.addEventListener('click', handleClickOutside);
    return () => document.removeEventListener('click', handleClickOutside);
  }, [openDropdown]);

  // Get category color
  const getCategoryColor = (categoryName) => {
    if (!categoryName) return "#4F46E5";
    // Try exact match first, then case-insensitive match
    let category = categories.find(c => c.name === categoryName);
    if (!category) {
      category = categories.find(c => c.name.toLowerCase() === categoryName.toLowerCase());
    }
    return category ? category.color : "#4F46E5";
  };

  // Create new post (admin only)
  const handleCreatePost = () => {
    navigate("/admin/blog/create");
  };

  if (isLoading) {
    return (
      <section className="relative font-inter blog">
        <div className="py-16 intro">
          <div className="container px-6 mx-auto 2xl:max-w-7xl xl:px-20 md:px-3">
            <div className="py-12 text-center">
              <div className="w-16 h-16 mx-auto border-t-2 border-b-2 border-pink-600 rounded-full animate-spin"></div>
              <p className="mt-4 text-pink-600">Loading Events...</p>
            </div>
          </div>
        </div>
      </section>
    );
  }

  // Get unique subcategories from posts (with their parent category)
  const getUniqueSubcategories = () => {
    const subcategoryMap = new Map();
    
    posts.forEach(post => {
      if (post.is_published) {
        // Check if post has subcategories in the categories array (format: [mainCategory, sub1, sub2, ...])
        const categoriesArray = post.categories || [];
        if (categoriesArray.length > 1) {
          // Get all subcategories (items after the first one which is main category)
          for (let i = 1; i < categoriesArray.length; i++) {
            const sub = categoriesArray[i];
            if (sub && !subcategoryMap.has(sub)) {
              subcategoryMap.set(sub, {
                name: sub,
                mainCategory: categoriesArray[0],
                posts: []
              });
            }
          }
        }
        
        // Also check subcategory field directly
        if (post.subcategory) {
          const sub = post.subcategory;
          if (!subcategoryMap.has(sub)) {
            subcategoryMap.set(sub, {
              name: sub,
              mainCategory: post.category,
              posts: []
            });
          }
        }
      }
    });
    
    // Now collect all posts for each subcategory
    posts.forEach(post => {
      if (post.is_published) {
        const categoriesArray = post.categories || [];
        if (categoriesArray.length > 1) {
          for (let i = 1; i < categoriesArray.length; i++) {
            const sub = categoriesArray[i];
            if (subcategoryMap.has(sub)) {
              subcategoryMap.get(sub).posts.push(post);
            }
          }
        }
        
        if (post.subcategory && subcategoryMap.has(post.subcategory)) {
          subcategoryMap.get(post.subcategory).posts.push(post);
        }
      }
    });
    
    return Array.from(subcategoryMap.values());
  };

  // Get posts by subcategory
  const getPostsBySubcategory = (subcategoryName) => {
    return filterPosts(posts, activeCategory, subcategoryName, searchQuery).filter(post => post.is_published);
  };

  // Get unique categories from posts (fallback)
  const getUniqueCategories = () => {
    const categorySet = new Set();
    posts.forEach(post => {
      if (post.category && post.is_published) {
        categorySet.add(post.category);
      }
    });
    return Array.from(categorySet);
  };

  // Get posts by category (fallback)
  const getPostsByCategory = (categoryName) => {
    return filterPosts(posts, categoryName, activeSubcategory, searchQuery).filter(post => post.is_published);
  };

  const uniqueSubcategories = getUniqueSubcategories();
  const uniqueCategories = getUniqueCategories();
  const currentPosts = getCurrentPosts();
  const filteredPosts = filterPosts(posts, activeCategory, activeSubcategory, searchQuery);

  return (
    <section className="relative font-inter blog">
      <style>{`
        .blog-red-scrollbar::-webkit-scrollbar {
          width: 10px;
          height: 10px;
        }
        .blog-red-scrollbar::-webkit-scrollbar-track {
          background: rgba(0, 0, 0, 0.1);
          border-radius: 10px;
        }
        .blog-red-scrollbar::-webkit-scrollbar-thumb {
          background: #4b5563;
          border-radius: 10px;
        }
        .blog-red-scrollbar::-webkit-scrollbar-thumb:hover {
          background: #374151;
        }
      `}</style>
      {/* Hero Section */}
     <div className="intro relative overflow-hidden  h-[580px]  z-50">
<video
  autoPlay
  loop
  muted
  playsInline
  preload="metadata"
  poster="data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 1920 1080'%3E%3Crect fill='%23374151' width='1920' height='1080'/%3E%3C/svg%3E"
  className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 scale-[1] w-full h-full object-cover"
>
  <source src={egyptVideo} type="video/mp4" />
  Your browser does not support the video tag.
</video>
  {/* Dark overlay to make text readable - adjust opacity as needed */}
  <div className="absolute inset-0 bg-black/40" />

  {/* Your content */}
  <div className="container relative z-10 px-6 mx-auto 2xl:max-w-7xl xl:px-20 md:px-3">
    <div className="flex flex-wrap items-center justify-center md:justify-between gap-x-7 gap-y-9 md:flex-nowrap">
      <div className="font-bold text-white">
        <h2 className="text-[20px] font-bold leading-[40.69px] mb-16 mt-28">
         
        </h2>
        
        {/* Admin Create Button */}
        {isAdmin && (
          <div className="flex gap-3 mt-6">
            <Button 
              className="px-6 font-bold text-pink-700 bg-white rounded-full"
              onClick={handleCreatePost}
            >
              + Create New Post
            </Button>
            <Button
              color="warning"
              onClick={() => navigate("/admin/blog")}
              className="px-6 text-white rounded-full bg-gradient-to-r from-pink-500 to-orange-500"
              startContent={<FiSettings className="text-lg" />}
            >
              Manage Events
            </Button>
          </div>
        )}
      </div>
    </div>
  </div>
</div>

      {/* Blog Content */}
      <div className="relative w-full blog-content py-14">
        {/* Decorative Bubbles */}
        <div className="absolute left-0 top-0 sm:w-[367px] w-[80%] h-[362px] z-10 bg-aboutBuble"></div>
  <div className="absolute left-0 bottom-[0] sm:w-[344px] w-[80%] h-[384.17px] z-10 bg-aboutOrangeBuble"></div>
  <div className="absolute right-0 bottom-[15%] sm:w-[260px] w-[50%] h-[348px] z-10 bg-aboutPrint"></div>

        <div className="relative z-20 w-full px-4 md:px-2 lg:px-16">
          {/* Categories Section */}
          <div className="mb-12 categories">
            {/* <h3 className="text-38px font-bold leading-[43.7px] bg-clip-text text-transparent bg-mainGradiant mb-6 text-center">
              Browse by Category
            </h3> */}
            
            {/* Search Bar */}
            {/* <div className="max-w-md mx-auto mb-8">
              <div className="relative">
                <Input
                  type="text"
                  placeholder="Search articles..."
                  value={searchQuery}
                  onChange={(e) => setSearchQuery(e.target.value)}
                  className="w-full"
                  classNames={{
                    input: "bg-white  rounded-full border-pink-500 shadow-md"
                  }}
                  startContent={
                    <div className="w-5 h-5 ml-3">
                      <img
                        src={searchIcon}
                        alt="Search"
                        className="w-full h-full"
                      />
                    </div>
                  }
                />
              </div>
            </div> */}

            <div className="flex flex-wrap justify-center gap-4">
              <button
                onClick={() => {
                  setActiveCategory("All");
                  setActiveSubcategory("");
                }}
                className={`px-2 py-3 rounded-full font-semibold transition-all duration-300 ${
                  activeCategory === "All"
                    ? "bg-mainGradiant text-white"
                    : "bg-gray-200 text-gray-700 hover:bg-gray-300"
                }`}
              >
                All Events ({filteredPosts.length})
              </button>
              {categories.map((category) => {
                const isActive = activeCategory === category.name;
                const availableSubs = getAvailableSubcategories(category.name);
                const hasSubcategories = availableSubs.length > 0;
                
                return (
                  <div key={category.name} className="relative">
                    <button
                      onClick={(e) => {
                        e.stopPropagation();
                        setActiveCategory(category.name);
                        if (!hasSubcategories) {
                          setActiveSubcategory("");
                        } else {
                          // Toggle dropdown
                          setOpenDropdown(openDropdown === category.name ? null : category.name);
                        }
                      }}
                      className={`px-6 py-3 rounded-full font-semibold transition-all duration-300 ${
                        isActive
                          ? "text-white"
                          : "text-gray-700"
                      }`}
                      style={{
                        backgroundColor: isActive ? category.color : "#E5E7EB"
                      }}
                    >
                      {category.name} ({category.count})
                      {hasSubcategories && (
                        <FiFilter className="inline-block w-4 h-4 ml-2" />
                      )}
                    </button>
                    
                    {/* Subcategory dropdown */}
                    {isActive && hasSubcategories && openDropdown === category.name && (
                      <div 
                        className="absolute top-full left-0 mt-2 z-50 bg-white rounded-xl shadow-xl border border-gray-100 min-w-[200px] max-h-[300px] overflow-y-auto blog-red-scrollbar"
                        onClick={(e) => e.stopPropagation()}
                      >
                        <div className="p-2" onClick={(e) => e.stopPropagation()}>
                          <button
                            onClick={() => {
                              setActiveSubcategory("");
                              setOpenDropdown(null);
                            }}
                            className={`w-full text-left px-4 py-2 rounded-lg text-sm transition-colors ${
                              activeSubcategory === ""
                                ? "bg-blue-50 text-blue-600 font-medium"
                                : "text-gray-700 hover:bg-gray-50"
                            }`}
                          >
                            All {category.name}
                          </button>
                          {availableSubs.map((sub) => (
                            <button
                              key={sub.value}
                              onClick={() => {
                                setActiveSubcategory(sub.value);
                                setOpenDropdown(null);
                              }}
                              className={`w-full text-left px-4 py-2 rounded-lg text-sm transition-colors ${
                                activeSubcategory === sub.value
                                  ? "bg-blue-50 text-blue-600 font-medium"
                                  : "text-gray-700 hover:bg-gray-50"
                              }`}
                            >
                              {sub.label}
                            </button>
                          ))}
                        </div>
                      </div>
                    )}
                  </div>
                );
              })}
            </div>
          </div>

          {/* Featured Post */}
       

          {/* Posts by Subcategory Rows */}
          {activeCategory === "All" ? (
            // Show posts organized by subcategory rows
            uniqueSubcategories.length > 0 ? (
              uniqueSubcategories.map((subData) => {
                const subcategoryPosts = getPostsBySubcategory(subData.name);
                if (subcategoryPosts.length === 0) return null;
                
                // Get the subcategory label
                const subLabel = getSubcategoryLabel(subData.mainCategory, subData.name) || subData.name;
                
                return (
                  <div key={subData.name} className="mb-16 category-section">
                    {/* Subcategory Header */}
                    <div className="flex items-center justify-between mb-6">
                      <h3 
                        className="text-2xl font-bold text-transparent bg-clip-text"
                        style={{ 
                          background: "linear-gradient(90deg, #FF7E5F 0%, #E65CA7 100%)",
                          WebkitBackgroundClip: "text",
                          WebkitTextFillColor: "transparent"
                        }}
                      >
                        {subLabel}
                        <span className="ml-2 text-sm font-normal text-gray-500">
                          ({subcategoryPosts.length} {subcategoryPosts.length === 1 ? 'event' : 'events'})
                        </span>
                      </h3>
                      {/* <Button
                        size="sm"
                        variant="flat"
                        className="rounded-full"
                        style={{ 
                          backgroundColor: getCategoryHexColor(subData.mainCategory) + '20',
                          color: getCategoryHexColor(subData.mainCategory)
                        }}
                        onClick={() => {
                          setActiveSubcategory(subData.name);
                          setCurrentPage(1);
                        }}
                      >
                        View All
                      </Button> */}
                    </div>
                    
                    {/* Posts Grid for this subcategory - Horizontal Scroll */}
                    <div className="flex gap-3 pb-4 overflow-x-auto snap-x snap-mandatory blog-red-scrollbar">
                      {subcategoryPosts.slice(0, 6).map((post) => (
                        <PostCard 
                          key={post.id} 
                          post={post} 
                          navigate={navigate}
                          getCategoryColor={getCategoryColor}
                          getCategoryHexColor={getCategoryHexColor}
                          getSubcategoryLabel={getSubcategoryLabel}
                          formatDate={formatDate}
                          handleLike={handleLike}
                          toggleComments={toggleComments}
                          expandedComments={expandedComments}
                          newComments={newComments}
                          setNewComments={setNewComments}
                          handleAddComment={handleAddComment}
                          handleShare={handleShare}
                          featuredImg={featuredImg}
                          navShawarImg={navShawarImg}
                          likeIcon={likeIcon}
                          unlikeIcon={unlikeIcon}
                          commentIcon={commentIcon}
                          shareIcon={shareIcon}
                        />
                      ))}
                    </div>
                  </div>
                );
              })
            ) : (
              // Fallback: Show by categories if no subcategories
              uniqueCategories.length > 0 ? (
                uniqueCategories.map((categoryName) => {
                  const categoryPosts = getPostsByCategory(categoryName);
                  if (categoryPosts.length === 0) return null;
                  
                  return (
                    <div key={categoryName} className="mb-16 category-section">
                      {/* Category Header */}
                      <div className="flex items-center justify-between mb-6">
                        <h3 
                          className="text-2xl font-bold text-transparent bg-clip-text"
                          style={{ 
                            background: "linear-gradient(90deg, #FF7E5F 0%, #E65CA7 100%)",
                            WebkitBackgroundClip: "text",
                            WebkitTextFillColor: "transparent"
                          }}
                        >
                          {categoryName}
                          <span className="ml-2 text-sm font-normal text-gray-500">
                            ({categoryPosts.length} {categoryPosts.length === 1 ? 'event' : 'events'})
                          </span>
                        </h3>
                        <Button
                          size="sm"
                          variant="flat"
                          className="rounded-full"
                          style={{ 
                            backgroundColor: getCategoryHexColor(categoryName) + '20',
                            color: getCategoryHexColor(categoryName)
                          }}
                          onClick={() => {
                            setActiveCategory(categoryName);
                            setCurrentPage(1);
                          }}
                        >
                          View All
                        </Button>
                      </div>
                      
                      {/* Posts Grid for this category - Horizontal Scroll */}
                      <div className="flex gap-6 pb-4 overflow-x-auto snap-x snap-mandatory blog-red-scrollbar">
                        {categoryPosts.slice(0, 6).map((post) => (
                          <PostCard 
                            key={post.id} 
                            post={post} 
                            navigate={navigate}
                            getCategoryColor={getCategoryColor}
                            getCategoryHexColor={getCategoryHexColor}
                            getSubcategoryLabel={getSubcategoryLabel}
                            formatDate={formatDate}
                            handleLike={handleLike}
                            toggleComments={toggleComments}
                            expandedComments={expandedComments}
                            newComments={newComments}
                            setNewComments={setNewComments}
                            handleAddComment={handleAddComment}
                            handleShare={handleShare}
                            featuredImg={featuredImg}
                            navShawarImg={navShawarImg}
                            likeIcon={likeIcon}
                            unlikeIcon={unlikeIcon}
                            commentIcon={commentIcon}
                            shareIcon={shareIcon}
                          />
                        ))}
                      </div>
                    </div>
                  );
                })
              ) : (
                <div className="py-12 text-center">
                  <p className="text-xl text-gray-500">No articles found.</p>
                </div>
              )
            )
          ) : (
            // Show filtered posts (single category selected)
            <>
              <div className="flex items-center justify-between mb-6">
                <h3 className="text-2xl font-bold text-transparent bg-clip-text"
                  style={{ 
                    background: "linear-gradient(90deg, #FF7E5F 0%, #E65CA7 100%)",
                    WebkitBackgroundClip: "text",
                    WebkitTextFillColor: "transparent"
                  }}>
                  {activeCategory}
                  <span className="ml-2 text-sm font-normal text-gray-500">
                    ({currentPosts.length} {currentPosts.length === 1 ? 'event' : 'events'})
                  </span>
                </h3>
                <Button
                  size="sm"
                  variant="flat"
                  className="bg-gray-200 rounded-full"
                  onClick={() => {
                    setActiveCategory("All");
                    setCurrentPage(1);
                  }}
                >
                  View All Categories
                </Button>
              </div>
              
              {currentPosts.length === 0 ? (
                <div className="py-12 text-center">
                  <p className="text-xl text-gray-500">No articles found matching your criteria.</p>
                  <Button 
                    className="mt-4 text-white bg-mainGradiant"
                    onClick={() => {setActiveCategory("All"); setSearchQuery("");}}
                  >
                    Clear Filters
                  </Button>
                </div>
              ) : (
                <div className="flex gap-6 pb-4 overflow-x-auto snap-x snap-mandatory blog-red-scrollbar">
                  {currentPosts.map((post) => (
                    <PostCard 
                      key={post.id} 
                      post={post} 
                      navigate={navigate}
                      getCategoryColor={getCategoryColor}
                      getCategoryHexColor={getCategoryHexColor}
                      getSubcategoryLabel={getSubcategoryLabel}
                      formatDate={formatDate}
                      handleLike={handleLike}
                      toggleComments={toggleComments}
                      expandedComments={expandedComments}
                      newComments={newComments}
                      setNewComments={setNewComments}
                      handleAddComment={handleAddComment}
                      handleShare={handleShare}
                      featuredImg={featuredImg}
                      navShawarImg={navShawarImg}
                      likeIcon={likeIcon}
                      unlikeIcon={unlikeIcon}
                      commentIcon={commentIcon}
                      shareIcon={shareIcon}
                    />
                  ))}
                </div>
              )}

              {/* Pagination */}
              {totalPages > 1 && activeCategory !== "All" && (
                <div className="flex items-center justify-center gap-2 mt-12">
                  <Button
                    className={`rounded-full px-4 ${currentPage === 1 ? 'bg-gray-200 text-gray-500' : 'bg-mainGradiant text-white'}`}
                    onClick={() => setCurrentPage(prev => Math.max(prev - 1, 1))}
                    disabled={currentPage === 1}
                  >
                    Previous
                  </Button>
                  
                  {[...Array(totalPages)].map((_, index) => (
                    <Button
                      key={index}
                      className={`w-10 h-10 rounded-full ${
                        currentPage === index + 1
                          ? 'bg-mainGradiant text-white'
                          : 'bg-gray-200 text-gray-700 hover:bg-gray-300'
                      }`}
                      onClick={() => setCurrentPage(index + 1)}
                    >
                      {index + 1}
                    </Button>
                  ))}
                  
                  <Button
                    className={`rounded-full px-4 ${currentPage === totalPages ? 'bg-gray-200 text-gray-500' : 'bg-mainGradiant text-white'}`}
                    onClick={() => setCurrentPage(prev => Math.min(prev + 1, totalPages))}
                    disabled={currentPage === totalPages}
                  >
                    Next
                  </Button>
                </div>
              )}
            </>
          )}

          {/* Newsletter Section */}
        <div className="p-10 mt-16 text-center newsletter bg-mainGradiant rounded-4xl">
      <h3 className="mb-4 text-3xl font-bold text-white">
        Stay Updated
      </h3>
      <p className="mb-6 text-lg text-white opacity-90">
        Subscribe to our newsletter and never miss a new post.
      </p>
      
      {!isAuthenticated ? (
        // Message for non-logged-in users
        <div className="max-w-md mx-auto">
          <div className="p-6 border bg-white/20 backdrop-blur-sm rounded-3xl border-white/30">
            <p className="mb-4 text-white">
              To subscribe to our newsletter, please login or create an account.
            </p>
            <div className="flex flex-wrap justify-center gap-4">
              <Button 
                className="px-8 font-bold bg-white rounded-full text-mainGradiant"
                onClick={() => navigate("/login")}
              >
                Login
              </Button>
              <Button 
                className="px-8 font-bold text-white bg-transparent border-2 border-white rounded-full hover:bg-white/10"
                onClick={() => navigate("/signup")}
              >
                Sign Up
              </Button>
            </div>
          </div>
        </div>
      ) : subscriptionSuccess ? (
        // Success message
        <div className="max-w-md mx-auto">
          <div className="inline-flex items-center justify-center px-6 py-4 text-green-800 bg-green-100 border-2 border-green-400 rounded-3xl">
            <svg className="w-6 h-6 mr-3" fill="currentColor" viewBox="0 0 20 20">
              <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
            </svg>
            <div>
              <p className="font-bold">Successfully subscribed!</p>
              <p className="text-sm">You'll receive updates at {email}</p>
            </div>
          </div>
        </div>
      ) : (
        // Subscription form for logged-in users
        <div className="max-w-md mx-auto">
          <div className="p-6 border bg-white/10 backdrop-blur-sm rounded-3xl border-white/20">
            <p className="mb-4 text-sm text-white">
              You're logged in as <span className="font-semibold">{email}</span>. 
              Enter your email to subscribe:
            </p>
            
            <div className="flex flex-wrap justify-center gap-4">
              <Input
                type="email"
                placeholder="Enter your email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className="md:flex-1 min-w-[250px]"
                classNames={{
                  input: "bg-white border-blue-900 rounded-full"
                }}
                onKeyPress={(e) => e.key === "Enter" && handleSubscribe()}
                disabled={isSubscribing}
                endContent={
                  <div className="text-gray-500">
                    @
                  </div>
                }
              />
              <Button 
                className="bg-white text-mainGradiant font-bold rounded-full px-8 min-w-[120px]"
                onClick={handleSubscribe}
                disabled={isSubscribing}
              >
                {isSubscribing ? (
                  <div className="flex items-center">
                    <div className="w-4 h-4 mr-2 border-2 rounded-full border-mainGradiant border-t-transparent animate-spin"></div>
                    Subscribing...
                  </div>
                ) : "Subscribe"}
              </Button>
            </div>
            
            <p className="mt-4 text-xs text-white opacity-70">
              By subscribing, you agree to receive newsletters from us. 
              You can unsubscribe anytime.
            </p>
          </div>
        </div>
      )}
    </div>

      {/* Share Modal Toast */}
      {shareModal.show && (
        <div className="fixed z-50 px-6 py-3 text-white bg-green-500 shadow-lg top-24 right-8 rounded-xl animate-bounce">
          Link copied to clipboard!
        </div>
      )}
        </div>
      </div>
    </section>
  );
};

export default Blog;